import React from 'react';
import { BottomArea, Button } from '../styles';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import CircularProgress from '@mui/material/CircularProgress';
import styled from 'styled-components';

const StyledBottom = styled(BottomArea)`
  .bottom-bar-next-content {
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }
  .bottom-bar-spinner {
    color: #ffffff;
  }
`;

interface BottomBarProps {
  disabled: boolean;
  backTitle: string;
  nextTitle: string;
  handleBack?: () => unknown;
  handleNext?: () => unknown;
  hideBack?: boolean;
  hideNext?: boolean;
  fixToBottom?: boolean;
  errorText?: string;
  isLoading?: boolean;
}

export const BottomBar: React.FC<BottomBarProps> = ({
  disabled,
  backTitle,
  nextTitle,
  handleBack = () => { /* noop */ },
  handleNext = () => { /* noop */ },
  hideBack = false,
  hideNext = false,
  fixToBottom = true,
  errorText = '',
  isLoading = false,
}) => (
  <StyledBottom fixToBottom={fixToBottom} className="bottom-bar">
    {errorText && (
      <TrueImpactText color="critical" className="error-text">
        {errorText}
      </TrueImpactText>
    )}
    <div className="buttons-wrapper">
      <div className="buttons">
        {!hideBack && (
          <Button
            style={{ maxWidth: backTitle?.length <= 4 ? '20%' : '35%' }}
            disabled={disabled || isLoading}
            onClick={handleBack}
            variant="outlined"
          >
            {backTitle}
          </Button>
        )}
        {!hideNext && (
          <Button
            style={{ maxWidth: backTitle?.length <= 4 ? '50%' : '35%' }}
            disabled={disabled || isLoading}
            onClick={handleNext}
            variant="outlined"
            className="submit"
          >
            <span className="bottom-bar-next-content">
              {nextTitle}
              {isLoading && (
                <CircularProgress size={18} className="bottom-bar-spinner" />
              )}
            </span>
          </Button>
        )}
      </div>
    </div>
  </StyledBottom>
);
